<template>
  <div class="MandateBar"
       v-if="isLogin">
    <no-ssr>
      <span class="tag">全站通VIP加赠1年</span>
      <!--  企业身份   -->

      <a
          v-if="companyVipState == 1"
          class="bar company "
          :href="PAGE_PATH.PAYMENT.COMPANY"
          target="_blank"
          @click="tag"
      >
        <div class="icon-box">
          <i class="icon"/>
        </div>
        <div class="mandate-text">当前帐号已获得【企业商用授权】</div>
        <div
            class="icon-btn">升级授权
        </div>
      </a>


<!--                :href=" vipType == 1 ? PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.COMPANY : PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE"
-->
      <a
          v-else-if="personVipState == 1 || businessVipState == 1"
          class="bar business "
          :href="personLink"
          @click="tag"
          v-hover-delay="showDownloadInterestModal"
          @mouseleave="closeDownloadInterestModal"
          @mouseover="setUpgradeLink(personLink)"
          target="_blank"
      >
        <div class="icon-box">
          <i class="icon"/>
        </div>
        <div class="mandate-text">
          {{ '当前帐号未获得【企业商用授权】' }}
        </div>
        <div
            class="icon-btn">
          升级授权
        </div>
      </a>

      <a
          v-else
          class="bar person "
          :href="detail.layer == 4 ? PAY_COMPANY :PAY_PERSON"
          @click="tag"
          target="_blank"
          v-hover-delay="showDownloadInterestModal"
          @mouseover="setUpgradeLink(detail.layer == 4 ? PAY_COMPANY :PAY_PERSON)"
          @mouseleave="closeDownloadInterestModal"
      >
        <div class="icon-box">
          <i class="icon"/>
        </div>
        <div class="mandate-text">
          {{ '当前帐号未获得【商用授权】' }}
        </div>
        <div
            class="icon-btn">
          购买授权
        </div>
      </a>


      <!--      <template v-if="vipType == 4">
              <a
                class="bar company "
                :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.COMPANY"
                target="_blank"
                @click="tag"
              >
                <div class="icon-box">
                  <i class="icon"/>
                </div>
                <div class="mandate-text">当前帐号已获得【企业商用授权】</div>
                <div
                  class="icon-btn">升级授权
                </div>
              </a>
            </template>

            <template v-else-if="vipType == 3">

              <a
                v-if="vipType >= detail.layer"
                class="bar business2"
                :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE"
                @click="tag"
                target="_blank"
              >
                <div class="icon-box">
                  <i class="icon"/>
                </div>
                <div class="mandate-text">
                  {{ '当前帐号已获得【个人商用授权】' }}
                </div>
                <div
                  class="icon-btn">
                  {{ '升级授权' }}
                </div>
              </a>

              &lt;!&ndash;      :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.COMPANY"&ndash;&gt;

              &lt;!&ndash;
               ({
                          isShow: true,
                          upgradeLink: PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE
                        })
               &ndash;&gt;
              <a
                v-hover-delay="showDownloadInterestModal"
                @mouseleave="closeDownloadInterestModal"
                @mouseover="setUpgradeLink(PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE)"
                v-else
                class="bar business "
                :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE"
                @click="tag"
                target="_blank"
              >
                <div class="icon-box">
                  <i class="icon"/>
                </div>
                <div class="mandate-text">
                  {{ '当前帐号未获得【企业商用授权】' }}
                </div>
                <div
                  class="icon-btn">
                  {{ '升级授权' }}
                </div>
              </a>

            </template>

            <template v-else-if="vipType == 2 || vipType == 1 ">

              &lt;!&ndash;
                ({
                          isShow: true,
                          upgradeLink: vipType == 1 ? PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.COMPANY : PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE
                        })
                &ndash;&gt;
              <a
                v-if="detail.layer == 4"
                class="bar business "
                :href="
                vipType == 1 ? PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.COMPANY : PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE"
                @click="tag"
                v-hover-delay="showDownloadInterestModal"
                @mouseleave="closeDownloadInterestModal"
                @mouseover="setUpgradeLink(vipType == 1 ? PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.COMPANY : PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE)"
                target="_blank"
              >
                <div class="icon-box">
                  <i class="icon"/>
                </div>
                <div class="mandate-text">
                  {{ '当前帐号未获得【企业商用授权】' }}
                </div>
                <div
                  class="icon-btn">
                  {{ vipType == 1 ? '购买授权' : '升级授权' }}
                </div>
              </a>


              &lt;!&ndash;
              ({
                  isShow: true,
                  upgradeLink: vipType == 1 ? PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.BUSINESS : PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE
                })
              &ndash;&gt;
              <a
                v-else
                class="bar person "
                :href="
              vipType == 1 ? PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.BUSINESS : PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE
      "
                @click="tag"
                target="_blank"
                v-hover-delay="showDownloadInterestModal"
                @mouseover="setUpgradeLink(vipType == 1 ? PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.BUSINESS : PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE)"
                @mouseleave="closeDownloadInterestModal"
              >
                <div class="icon-box">
                  <i class="icon"/>
                </div>
                <div class="mandate-text">
                  {{ '当前帐号未获得【商用授权】' }}
                </div>
                <div
                  class="icon-btn">
                  {{ vipType == 1 ? '购买授权' : '升级授权' }}
                </div>
              </a>

            </template>-->


      <slot name="MandateBarContent"></slot>
    </no-ssr>
  </div>
</template>

<script>
import {getCookie} from "~/utils/auth";
import {PAGE_PATH} from '@/constant/PAGE_PATH'
import {tag} from "@/utils/statUtil";

/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';
import _ from 'lodash'

let {COMPANY, BUSINESS, PERSON, DEFAULT} = CON_COMMON.CON_PAY.VIP_GRADE


/* 引入组件 */

/* 引入VUEX */
import {mapState} from "vuex";
import {PAY_PERSON, PAY_COMPANY} from "@/constant/_Public/Path";

/* 引入API */

export default {
  name: "MandateBar",
  components: {},
  props: {
    /* 详情 */
    detail: {
      type: Object,
      default: () => {
      }
    },
  },
  computed: {
    ...mapState('user',
        [
          'isLogin',
          'personVipState',
          'personVipInfo',
          'businessVipState',
          'businessVipInfo',
          'companyVipState',
          'companyVipInfo',
          'isHasUserCoupon',
          'isSwitchAccountType',
          'isSwitchCompanyMain',
        ]
    ),
    ...mapState('pic', ['DownloadInterestModal', 'DownloadInterestModalTimer']),

    isOpenTimer() {

      if (this.DownloadInterestModal && this.DownloadInterestModal.isOpenTimer) {
        return this.DownloadInterestModal.isOpenTimer;
      }
      return false;
    },

    personLink(){

      let personVipState = getCookie('personVipState');
      let personVipInfo = JSON.parse(getCookie('personVipInfo'));
      let businessVipState = getCookie('businessVipState');
      let businessVipInfo = JSON.parse(getCookie('businessVipInfo'));
      let companyVipState = getCookie('companyVipState');

      let {remaining_days, vip, module, end_time} = personVipInfo

      let person_remaining_days = personVipInfo.remaining_days
      let business_remaining_days = businessVipInfo.remaining_days

      /* 仅个人 */
      if (personVipState == 1 && businessVipState != 1) {
        // return CON_COMMON.CON_BASIC.PAY_PERSON_UPGRADE
        if (person_remaining_days <= 365) {
          return CON_COMMON.CON_BASIC.PAY_UPGRADE
        } else {
          return CON_COMMON.CON_BASIC.PAY_COMPANY
        }
      } else if (personVipState != 1 && businessVipState == 1) {
        // return CON_COMMON.CON_BASIC.PAY_PERSON_UPGRADE
        if (business_remaining_days <= 365) {
          return CON_COMMON.CON_BASIC.PAY_UPGRADE
        } else {
          return CON_COMMON.CON_BASIC.PAY_COMPANY
        }
      }

      /*  */
      else if (personVipState == 1 && businessVipState == 1) {
        // return CON_COMMON.CON_BASIC.PAY_UPGRADE + '/1-' + VIP_MANAGE.COMPANY.All_PURPOSE_NEW.ID
        if (person_remaining_days <= 365 || business_remaining_days <= 365) {
          return CON_COMMON.CON_BASIC.PAY_UPGRADE
        } else {
          return CON_COMMON.CON_BASIC.PAY_COMPANY
        }

        /* 检查普通终身是否过期，是否是普通/商用体验VIP */

      }

    }
  },
  watch: {
    isSwitchAccountType: {
      handler(n, o) {
        console.log(n)
        if (n == true) {
          console.log('-- isSwitchAccountType 登录检查VIP --')
          setTimeout(() => {
            this.init();
          }, 500)
        }
      }
    },
    isSwitchCompanyMain: {
      handler(n, o) {
        console.log(n)
        if (n == true) {
          // console.log('-- PicButtonGroup isSwitchCompanyMain --')
          setTimeout(() => {
            this.init();
          }, 500)
        }
      }
    },

    isOpenTimer: {
      handler: _.debounce(function (n, o) {
        if (this.closeTimer === null) {
          console.log('Timer has been cancelled.')
        } else {
          console.log('Timer will still run.')
          clearTimeout(this.closeTimer)
        }
      }, 2000),
    },


  },

  data() {
    return {
      vipType: -1,
      PAGE_PATH,
      closeTimer: null,
      count: 0,
      PAY_PERSON,
      PAY_COMPANY
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    clearInterval(this.closeTimer)
  },
  methods: {

    init() {
      this.$store.commit('user/SET_SWITCH_ACCOUNT_TYPE', false)
      this.vipType = this.getUserMaxVip();
      console.log(this.getUserMaxVip())
    },

    getUserMaxVip() {
      let personVipState = getCookie('personVipState')
      let businessVipState = getCookie('businessVipState')
      let companyVipState = getCookie('companyVipState')
      if (companyVipState == 1) {
        return 4
      } else if (businessVipState == 1) {
        return 3
      } else if (personVipState == 1) {
        return 2
      } else {
        return 1
      }
    },
    tag() {
      tag('充值:详情页授权提示:图片:click')
    },

    MandateBarHover() {

      this.$emit("MandateBarHover")
      /*/!* 检测是否显示权益框 *!/
      if (this.vipType < this.detail.layer) {
        this.$refs.DownloadInterestModal.isShow = true;
        this.$refs.DownloadInterestModal.isOpenTimer = true;
      }*/
    },
    MandateBarHoverL() {
      // this.$refs.DownloadInterestModal.isShow = false
    },

    showDownloadInterestModal() {

      return false;

      /* 判断定时器弹框是否关闭 */
      if (this.DownloadInterestModal.isOpenTimer == true) {
        return false;
      }

      let params = {
        isShow: true,
        // upgradeLink: fnCommon.fnUser.getUserVipUpgradeLinkByPicLayer(this.detail.layer)
        upgradeLink: this.upgradeLink
      }
      clearInterval(this.closeTimer)
      this.count = 0;
      fnCommon.fnPic.showDownloadInterestModal(true, params);
    },

    closeDownloadInterestModal() {
      if (this.DownloadInterestModal.isOpenTimer == true) {
        return false;
      }

      this.closeTimer = setInterval(() => {
        // console.log( 'isOpenTimer' + this.DownloadInterestModal.isOpenTimer )
        if (this.DownloadInterestModal.isOpenTimer == true) {
          clearInterval(this.closeTimer);
          this.count = 0;
        } else {
          this.count += 1;
          // console.log('count'+ this.count)
          if (this.count >= 5) {
            fnCommon.fnPic.showDownloadInterestModal(false);
            clearInterval(this.closeTimer);
            this.count = 0;
          }
        }
      }, 1000)
    },
    setUpgradeLink(link) {

      if (this.DownloadInterestModal.isOpenTimer == true) {
        return false;
      }

      console.log('link')
      console.log(link)
      this.upgradeLink = link

    }
  }
}
</script>

<style lang="scss" scoped>


@mixin BarItem($bgImg,$iconImg,$btnImg) {
  width: 430px;
  height: 48px;
  //background: linear-gradient(180deg, #FFF6EC 0%, #FFECDA 71%, #FEE0C6 100%);
  @include BgImage(430px, 48px, 'tupian/detail/mandate-bar/#{$bgImg}.png?v=2');
  border-radius: 29px;
  position: relative;
  line-height: 44px;
  display: inline-flex;
  align-items: center;
  .icon-box {
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;

    .icon {
      @include BgImage(24px, 24px, 'tupian/detail/mandate-bar/#{$iconImg}.png?v=2');
    }
  }
  .mandate-text {
    font-size: 14px;
    color: #865742;
  }

  .icon-btn {
    width: 114px;
    height: 48px;
    @include Position(1, 2, 0, 0);
    font-size: 14px;
    color: #865742;
    line-height: 48px;
    text-align: center;

    &:hover {
      @include BgImage(114px, 48px, 'tupian/detail/mandate-bar/#{$btnImg}.png?v=2');
    }
  }
}

.MandateBar {
  margin-top: 20px;
  position: relative;
  display: inline-block;
  width: 430px;

  .tag{
    //width: 91px;
    height: 16px;
    font-size: 11px;
    color: #E9252C;
    line-height: 16px;
    text-align: right;
    font-style: normal;
    padding: 0px 4px 0 7px;
    position: absolute;
    top: -12px;
    right: -2px;
    background: #FFEC3B;
    clip-path: polygon(0 100%, 100% 100%, 100% 0, 5% 0);
    border-radius: 0 14px 14px 0;
    box-sizing: border-box;
    z-index: 5;
  }

  .company {
    @include BarItem('jin@bg', 'zi@icon2', 'zi@btn')
  }

  .person {
    @include BarItem('hong@bg', 'hong@icon', 'hong@btn');

    .icon-btn {
      @include ElementHover(#FFFFFF, '');
    }

    .mandate-text, {
      color: #F1613B;
    }

    .icon-btn {
      color: #FFFFFF;
    }
  }

  .business {
    @include BarItem('jin@bg', 'zi@icon1', 'jin@btn');

    .mandate-text, .icon-btn {
      color: #F1613B;
    }
  }

  .business2 {
    @include BarItem('zi@bg', 'zi@icon3', 'zi@btn');

    .mandate-text {
      color: #7272F8;
    }
  }
}


</style>
